import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import styled from 'styled-components';
import { purpurColorFunctionalBlack, purpurColorFunctionalWhite, purpurColorGray100, purpurColorGray200, purpurColorGray400, purpurColorPurple800, } from '@purpurds/tokens/color/variables';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
const StyledLink = styled(Link) `
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.$isCompleteWorkOrder ? 'flex-end' : 'space-between'};
  align-items: center;
  width: 100%;
  height: 48px;
  max-width: 750px;
  margin-bottom: ${props => props.$isCompleteWorkOrder ? '12px' : '5px'};
  background-color: ${props => props.$isCompleteWorkOrder ? purpurColorPurple800 : purpurColorFunctionalWhite};
  box-shadow: ${purpurShadowMd};
  border-radius: 4px;
  text-decoration: none;
  color: ${purpurColorFunctionalBlack};

  ${(props) => props.$isCompleteWorkOrder &&
    `
      flex-wrap: wrap;
      position: fixed;
      z-index: 2;
      bottom: 0;
      color: ${purpurColorFunctionalWhite};
  `}

  ${(props) => props.$disabled &&
    `
      background-color: ${purpurColorGray100};
      color: ${purpurColorGray400};
      pointer-events: none;
      box-shadow: none;
      cursor: not-allowed;
  `}
`;
const Content = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  ${props => props.$isLeft && 'margin-left: 15px;'}
  ${props => (props.$isRight || props.$isCompleteWorkOrder) && 'margin-right: 15px;'}
`;
const ContentLeftText = styled.span `
  font-size: 20px;
  margin-left: 10px;
`;
const NavigationButtonNumber = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  margin-left: 13px;
  color: ${props => (props.$disabled
    ? purpurColorGray400
    : purpurColorFunctionalBlack)};
  border: solid 1px ${props => (props.$disabled
    ? purpurColorGray400
    : purpurColorFunctionalBlack)};

  span {
    margin-bottom: 2px;
  }
`;
const StyledIcon = styled(Icon) `
  margin-left: 10px;
  color: inherit;
`;
const NavigationButton = ({ title, URL, id, isFetching = false, leftIcon, rightIcon, number, isCompleteWorkOrder = false, disabled = false, onClick, }) => {
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (_jsxs(StyledLink, { to: URL, onClick: handleClick, state: { id: id }, "$isCompleteWorkOrder": isCompleteWorkOrder, "$disabled": disabled, children: [_jsxs(Content, { "$isLeft": true, "$isCompleteWorkOrder": isCompleteWorkOrder, children: [!!leftIcon && leftIcon, _jsx(ContentLeftText, { children: title })] }), _jsxs(Content, { "$isRight": true, children: [!!number && number > 0 && (_jsx(NavigationButtonNumber, { "$disabled": disabled, children: _jsx("span", { children: number }) })), isFetching ? (_jsx(ClipLoader, { size: 16, color: purpurColorGray200 })) : (_jsx(StyledIcon, { svg: rightIcon || icons.arrowRight }))] })] }));
};
export default NavigationButton;
